"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.H3 = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.H3 = styled_components_1.default.h3 `
  font-size: 14px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 5px;
  text-align: left;
`;
//# sourceMappingURL=h3.js.map